const de = {
'Email':'E-Mail',
'party':'Partei',
'Party':'Partei',
'New party':'Neue Partei',
'Password':'Passwort',
'Remember me':'Erinnere dich an mich',
'Sign In':'Anmelden',
'Sign IN':'Anmelden',
'Sign UP':'Anmelden',
'Dont have an account':'Sie haben kein Konto?',
'Confirm Password':'Passwort bestätigen',
'Name':'Name',
'Company Name':'Firmenname',
'Address':'Adresse',
'Country':'Land',
'Select Country':'Land auswählen',
'State' : 'Bundesland',
'Select State':'Bundesland auswählen',
'City':'Stadt',
'Zip Code':'Postleitzahl',
'Phone Number':'Telefonnummer',
'Already have an account?':'Sie haben bereits ein Konto?',
'Register':'Registrieren',
'Contracts' : 'Verträge',
'Contract' : 'Vertrag',
'Contract Number' : 'Vertragsnummer',
'Logout':'Abmelden',
'Company':'Unternehmen',
'Users':'Benutzer',
'Type here...':'Hier tippen...',
'Dashboard':'Dashboard',
'Parties':'Parteien',
'View Party':'Partei anzeigen',
'Billing':'Abrechnung',
'Receipts':'Belege',
'Processing':'Verarbeitung',
'Reports':'Berichte',
'Search':'Suche',
'Clear':'Löschen',
'Search for Party (%for All)':'Nach Partei suchen (%für Alle)',
'Party Name':'Parteiname',
'Party Type':'Parteityp',
'Entity Type':'Einheitstyp',
'Select party Type':'Parteityp auswählen',
'Select Entity Type':'Einheitstyp auswählen',
'Establishment Date':'Gründungsdatum',
'Customer Portal':'Kundenportal',
'Tax Number':'Steueridentifikationsnummer',
'Sales Tax Code':'Umsatzsteuercode',
'Website':'Webseite',
'Website URL':'Website-URL',
'Prefix':'Präfix',
'Select Prefix':'Präfix auswählen',
'Address Reference':'Adressreferenz',
'Party Reference':'Parteireferenz',
'Mr':'Herr',
'Mrs':'Frau',
'Ms':'Frau',
'First Name':'Vorname',
'Middle Name':'Zweiter Vorname',
'Last Name':'Nachname',
'SSN / TIN Number':'Sozialversicherungsnummer / Steueridentifikationsnummer',
'ID Number':'ID-Nummer',
'Id Issue State':'Ausstellungsstaat der ID',
'Issue State':'Ausstellungsstaat',
'Date of Birth':'Geburtsdatum',
'Save' : 'Speichern',
'Cancel' : 'Abbrechen',
'Manage Party':'Partei verwalten',
'Cutomer Type':'Kundentyp',
'Customer Name':'Kundenname',    
'Tin Number':'Steuernummer',    
'SSN TIN Number':'SSN TIN-Nummer',    
'Add Address' : 'Adresse hinzufügen',
'Edit Address' : 'Adresse bearbeiten',
'Address Line 1' : 'Adresszeile 1',
'Address Line 2' : 'Adresszeile 2',
'Y':'Ja',
'Yes':'Ja',
'N':'Nein',
'No':'Nein',
'Bill To':'Rechnung an',
'Select Bill To':'Rechnung an auswählen',
'Ship To':'Versenden an',
'Select Ship To':'Versenden an auswählen',
'Install At':'Installieren bei',
'Select Install To':'Installieren bei auswählen',
'Search Install Address':'Installationsadresse suchen',
'Update':'Aktualisieren',
'Add Contact':'Kontakt hinzufügen',
'Edit Contact':'Kontakt bearbeiten',
'Phone No':'Telefonnummer',
'Mobile No':'Handynummer',
'Email Address':'E-Mail-Adresse',
'Manage Notification':'Benachrichtigung verwalten',
'Add Notification':'Benachrichtigung hinzufügen',
'Edit Notification':'Benachrichtigung bearbeiten',
'Notification':'Benachrichtigung',
'Notification Type':'Benachrichtigungstyp',
'Notification Reminder':'Benachrichtigungserinnerung',
'Select notification reminder ':'Benachrichtigungserinnerung auswählen ',
'Due Date Reminder':'Fälligkeitsdatumserinnerung',
'Type':'Typ',
'Select Notification Type':'Benachrichtigungstyp auswählen',
'Days In Advance':'Tage im Voraus',
'To':'An',
'Enable':'Aktivieren',
'Select':'Auswählen',
'New Notification':'Neue Benachrichtigung',
'Manage Address':'Adresse verwalten',
'Manage Contact':'Kontakt verwalten',
'New Address':'Neue Adresse',
'New Contact':'Neuer Kontakt',
'New Contract':'Neuer Vertrag',
'View Contracts':'Verträge anzeigen',
'Manage Contracts':'Verträge verwalten',
'Net Investment':'Nettoinvestition',
// 'Contract Number':'Vertragsnummer',
'Customer':'Kunde',
'Status':'Status',
'Start Date':'Startdatum',
'End Date':'Enddatum',
'Financed Amount':'Finanzierter Betrag',
'Search for Customer(%for All)':'Nach Kunde suchen (%für Alle)',
'Search for Contract(%for All)':'Nach Vertrag suchen (%für Alle)',
'Select Address':'Adresse auswählen',
'Bill to Address':'Rechnungsadresse',
'Contract Type':'Vertragstyp',
'List':'Liste',
'Loan':'Darlehen',
'Lease':'Leasing',
'Rental':'Miete',
'IRR/Interest p.a.':'IRR/Zinsen pro Jahr',
'Term':'Laufzeit (Monate)',
'Deposit Amount':'Anzahlungsbetrag',
'Fees (One-Time)':'Gebühren (Einmalzahlung)',
'Tax Rate (Rent)':'Steuersatz % (Miete)',
'Tax Rate (Fee)':'Steuersatz % (Gebühr)',
'Activate Contract':'Vertrag aktivieren',
'Contract Details' : 'Vertragsdetails',
'Amount Financed' : 'Finanzierter Betrag',
'Term (Months)' : 'Laufzeit (Monate)',
'Amount Billed' : 'In Rechnung gestellter Betrag',
'Unbilled Amount' : 'Nicht abgerechneter Betrag',
'Remaining Term (Months)' : 'Verbleibende Laufzeit (Monate)',
'No. of Assets' : 'Anzahl der Vermögenswerte',
'Amount Due' : 'Ausstehender Betrag',
'Day Past Due' : 'Vergangene Tage fällig',
'View Amort Schedules' : 'Amortisationspläne anzeigen',
'Key Information' : 'Wichtige Informationen',
'Last Payment Amount' : 'Betrag der letzten Zahlung',
'Next Due Amount' : 'Betrag der nächsten Fälligkeit',
'Payoff Amount' : 'Ablösebetrag',
'Concurrent Contracts' : 'Parallelverträge',
'Last Payment Date' : 'Datum der letzten Zahlung',
'Next Due Date' : 'Nächstes Fälligkeitsdatum',
'Auto Pay' : 'Automatische Zahlung',
'Exposure' : 'Exposition',
'Payment Schedules' : 'Zahlungspläne',
'No. Of Payments' : 'Anzahl der Zahlungen',
'Payment Type' : 'Zahlungstyp',
'Payment Amount' : 'Zahlungsbetrag',
'Frequency' : 'Frequenz der Zahlung',
'Asset' : 'Vermögenswert',
'Asset No' : 'Vermögenswert-Nr.',
'Asset Description' : 'Vermögenswert-Beschreibung',
'Asset Desc' : 'Vermögenswert-Beschreibung',
'VIN Number' : 'Fahrgestellnummer (VIN)',
'Vehical Cost' : 'Fahrzeugkosten',
'Asset Cost' : 'Vermögenswertkosten',
'Loan Amount':'Darlehensbetrag',
'Collateral Location':'Lage der Sicherheiten',
'In Service Date' : 'Inbetriebnahmedatum',
'Register Address' : 'Registrierungsadresse',
'License No' : 'Lizenznummer',
'Year' : 'Jahr',
'Dealer Payable' : 'An den Händler zu zahlender Betrag',
'License State' : 'Lizenzstaat',
'Manufacturer' : 'Hersteller',
'Make' : 'Marke',
'Model' : 'Modell',
'Use Purpose' : 'Verwendungszweck',
'Residual Value' : 'Restwert',
'Select Install Address' : 'Installationsadresse auswählen',
'Supplier Details' : 'Lieferantendetails',
'Vendor Name' : 'Lieferantenname',
'Select Vendor Name' : 'Lieferantenname auswählen',
'Search Vendor Name' : 'Lieferantenname suchen',
'Delivery Date' : 'Lieferdatum',
'In-Service Date' : 'Inbetriebnahmedatum',
'Mileage' : 'Kilometerstand',
'Vehicle Cost' : 'Fahrzeugkosten',
'Tax' : 'Steuer',
'Tax (%)' : 'Steuer (%)',
'Borrower' : 'Kreditnehmer',
'Dealer' : 'Händler',
'Trade In' : 'Inzahlungnahme',
'Registration' : 'Registrierung',
'Total Cost' : 'Gesamtkosten',
'Install Address' : 'Installationsadresse',
'Installation Details' : 'Installationsdetails',
'Down Payment' : 'Anzahlung',
'Add Assets' : 'Vermögenswerte hinzufügen',
'Add Payment Schedules' : 'Zahlungspläne hinzufügen',
'No of Payments' : 'Anzahl der Zahlungen',
'Rent' : 'Miete',
'Recurring Fee' : 'Wiederkehrende Gebühr',
'Fortnightly' : 'Zweiwöchentlich',
'Monthly' : 'Monatlich',
'Quartely' : 'Quartalsweise',
'Semi-annual' : 'Halbjährlich',
'Annual' : 'Jährlich',
'Edit Payment Schedules' : 'Zahlungspläne bearbeiten',
'New Payment Schedules' : 'Neue Zahlungspläne',
'Term(Months)' : 'Laufzeit (Monate)',
'Total Rent' : 'Gesamtmiete',
'Total Recurring Fees' : 'Gesamte wiederkehrende Gebühren',
'Total One Time Fees' : 'Gesamte einmalige Gebühren',
'Amort Schedules' : 'Amortisationspläne',
'Due Date' : 'Fälligkeitsdatum',
'Amount' : 'Betrag',
'Billing Amount' : 'Abrechnungsbetrag',
'Principal' : 'Hauptbetrag',
'Interest' : 'Zinsen',
'Remaining Balance' : 'Restbetrag',
'Date Billed' : 'Rechnungsdatum',
'Transaction Number' : 'Transaktionsnummer',
'View Assets' : 'Vermögenswerte anzeigen',
'Asset Number' : 'Vermögenswert-Nr.',
'License Number' : 'Lizenznummer',
'Registration Address' : 'Registrierungsadresse',
'Vehicle Cost (Pay To)' : 'Fahrzeugkosten (Zu zahlen)',
'Tax Amount' : 'Steuerbetrag',
'Trade In (Pay To)' : 'Inzahlungnahme (Zu zahlen)',
'Tax Amount (Pay To)' : 'Steuerbetrag (Zu zahlen)',
'Registration Cost' : 'Registrierungskosten',
'Registration Cost (Pay To)' : 'Registrierungskosten (Zu zahlen)',
'Down Payment (Pay To)' : 'Anzahlung (Zu zahlen)',
'Manage Invoices' : 'Rechnungen verwalten',
'Invoice Number' : 'Rechnungsnummer',
'Transaction Date' : 'Transaktionsdatum',
'Invoice Amount' : 'Rechnungsbetrag'

}
export default de;